/**
 * Morphing géométrique — cube → barres → camembert SVG → tableau
 */

const CELLS = [
  { id: 'orange', colorClass: 'dashboard-header-morph__cell--orange' },
  { id: 'violet', colorClass: 'dashboard-header-morph__cell--violet' },
  { id: 'blue', colorClass: 'dashboard-header-morph__cell--blue' },
];

const pieSlicePath = (startAngle, sweepAngle, cx = 50, cy = 50, r = 38) => {
  const rad = (deg) => (deg * Math.PI) / 180;
  const x1 = cx + r * Math.sin(rad(startAngle));
  const y1 = cy - r * Math.cos(rad(startAngle));
  const x2 = cx + r * Math.sin(rad(startAngle + sweepAngle));
  const y2 = cy - r * Math.cos(rad(startAngle + sweepAngle));
  const large = sweepAngle > 180 ? 1 : 0;
  return `M ${cx} ${cy} L ${x1} ${y1} A ${r} ${r} 0 ${large} 1 ${x2} ${y2} Z`;
};

const pieLabelPosition = (startAngle, sweepAngle, r = 47) => {
  const mid = startAngle + sweepAngle / 2;
  const rad = (mid * Math.PI) / 180;
  return {
    x: 50 + r * Math.sin(rad),
    y: 50 - r * Math.cos(rad),
  };
};

const pieSliceCenter = (startAngle, sweepAngle, r = 20) => {
  const mid = startAngle + sweepAngle / 2;
  const rad = (mid * Math.PI) / 180;
  return {
    x: 50 + r * Math.sin(rad),
    y: 50 - r * Math.cos(rad),
  };
};

const PIE_SLICES = [
  { id: 'orange', start: 0, sweep: 144, fill: '#f59e0b', label: '40%', labelColor: '#fbbf24' },
  { id: 'violet', start: 144, sweep: 126, fill: '#8b5cf6', label: '35%', labelColor: '#c4b5fd' },
  { id: 'blue', start: 270, sweep: 90, fill: '#3b82f6', label: '25%', labelColor: '#93c5fd' },
];

const TABLE_ROWS = [
  { id: 'orange', label: 'Produits', value: '39', color: '#f59e0b', glow: 'rgba(245, 158, 11, 0.35)' },
  { id: 'violet', label: 'Catégories', value: '6', color: '#8b5cf6', glow: 'rgba(139, 92, 246, 0.35)' },
  { id: 'blue', label: 'Refact.', value: '12', color: '#3b82f6', glow: 'rgba(59, 130, 246, 0.35)' },
];

/** Durées en secondes — le cycle total = somme des phases (redémarre après le tableau) */
const MORPH_TIMING = {
  cubeMorph: 3,
  cubeDigits: 3,
  barsMorph: 2,
  barsHold: 4,
  pieMorph: 2,
  pieHold: 4,
  tableMorph: 2,
  tableHold: 4,
};

const MORPH_CYCLE_S =
  MORPH_TIMING.cubeMorph +
  MORPH_TIMING.cubeDigits +
  MORPH_TIMING.barsMorph +
  MORPH_TIMING.barsHold +
  MORPH_TIMING.pieMorph +
  MORPH_TIMING.pieHold +
  MORPH_TIMING.tableMorph +
  MORPH_TIMING.tableHold;

const morphT = (seconds) => `${((seconds / MORPH_CYCLE_S) * 100).toFixed(4)}%`;

const MORPH_S = {
  cubeSpread: MORPH_TIMING.cubeMorph,
  cubeEnd: MORPH_TIMING.cubeMorph + MORPH_TIMING.cubeDigits,
  barsReady:
    MORPH_TIMING.cubeMorph + MORPH_TIMING.cubeDigits + MORPH_TIMING.barsMorph,
  barsHoldEnd:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold,
  pieReady:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph,
  pieHoldEnd:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    MORPH_TIMING.pieHold,
  tableReady:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    MORPH_TIMING.pieHold +
    MORPH_TIMING.tableMorph,
  cycleEnd: MORPH_CYCLE_S,
  barsLabelOrange:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph,
  barsLabelViolet:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    1,
  barsLabelBlue:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    2,
  pieZoomStart:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    1,
  pieZoomEnd:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    3,
  tableRowOrange:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    MORPH_TIMING.pieHold +
    MORPH_TIMING.tableMorph,
  tableRowViolet:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    MORPH_TIMING.pieHold +
    MORPH_TIMING.tableMorph +
    1,
  tableRowBlue:
    MORPH_TIMING.cubeMorph +
    MORPH_TIMING.cubeDigits +
    MORPH_TIMING.barsMorph +
    MORPH_TIMING.barsHold +
    MORPH_TIMING.pieMorph +
    MORPH_TIMING.pieHold +
    MORPH_TIMING.tableMorph +
    2,
};

const TABLE_ROW_APPEAR = {
  orange: MORPH_S.tableRowOrange,
  violet: MORPH_S.tableRowViolet,
  blue: MORPH_S.tableRowBlue,
};

/** Chiffres sous les barres (phase barres visibles, 1/s) */
const BAR_LABELS = [
  { id: 'orange', value: '39', color: '#fbbf24', left: '23.75%', top: '5.95rem' },
  { id: 'violet', value: '6', color: '#c4b5fd', left: '55.2%', top: '5.95rem' },
  { id: 'blue', value: '12', color: '#93c5fd', left: '86.3%', top: '5.95rem' },
];

const BAR_LABEL_APPEAR = {
  orange: MORPH_S.barsLabelOrange,
  violet: MORPH_S.barsLabelViolet,
  blue: MORPH_S.barsLabelBlue,
};

/** Chiffres / symboles flottants entre les cubes (phase cube uniquement) */
const CUBE_FLOATS = [
  { char: '3', left: '38%', top: '40%', color: '#fbbf24', delay: `${MORPH_TIMING.cubeMorph}s`, duration: '1.1s', drift: 'a' },
  { char: '%', left: '48%', top: '52%', color: '#c4b5fd', delay: `${MORPH_TIMING.cubeMorph + 0.15}s`, duration: '0.95s', drift: 'b' },
  { char: '+', left: '54%', top: '34%', color: '#93c5fd', delay: `${MORPH_TIMING.cubeMorph + 0.35}s`, duration: '1.05s', drift: 'c' },
  { char: '9', left: '42%', top: '58%', color: '#f59e0b', delay: `${MORPH_TIMING.cubeMorph + 0.05}s`, duration: '1.25s', drift: 'b' },
  { char: '−', left: '50%', top: '44%', color: '#e2e8f0', delay: `${MORPH_TIMING.cubeMorph + 0.5}s`, duration: '0.9s', drift: 'a' },
  { char: '6', left: '44%', top: '30%', color: '#a78bfa', delay: `${MORPH_TIMING.cubeMorph + 0.25}s`, duration: '1.15s', drift: 'c' },
  { char: '×', left: '36%', top: '50%', color: '#60a5fa', delay: `${MORPH_TIMING.cubeMorph + 0.4}s`, duration: '1.2s', drift: 'b' },
  { char: '12', left: '52%', top: '48%', color: '#fcd34d', delay: `${MORPH_TIMING.cubeMorph + 0.1}s`, duration: '1.35s', drift: 'a' },
];

export const DashboardHeaderMorph = () => (
  <div
    className="dashboard-header-morph"
    data-testid="dashboard-header-animation"
    aria-hidden="true"
  >
    <div className="dashboard-header-morph__glow dashboard-header-morph__glow--orange" />
    <div className="dashboard-header-morph__glow dashboard-header-morph__glow--violet" />
    <div className="dashboard-header-morph__glow dashboard-header-morph__glow--blue" />

    <div className="dashboard-header-morph__stage">
      <svg
        className="dashboard-header-morph__pie"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {PIE_SLICES.map(({ id, start, sweep, fill, label, labelColor }) => {
          const center = pieSliceCenter(start, sweep);
          const labelPos = pieLabelPosition(start, sweep);
          const origin = `${center.x}px ${center.y}px`;
          const labelOrigin = `${labelPos.x}px ${labelPos.y}px`;

          return (
            <g key={id} className={`dashboard-header-morph__pie-slice dashboard-header-morph__pie-slice--${id}`}>
              <g
                className={`dashboard-header-morph__pie-slice-body dashboard-header-morph__pie-slice-body--${id}`}
                style={{ transformBox: 'view-box', transformOrigin: origin }}
              >
                <path
                  d={pieSlicePath(start, sweep)}
                  fill={fill}
                  stroke="rgba(255,255,255,0.95)"
                  strokeWidth="1.4"
                  strokeLinejoin="round"
                />
              </g>
              <text
                className={`dashboard-header-morph__pie-label dashboard-header-morph__pie-label--${id}`}
                x={labelPos.x}
                y={labelPos.y}
                fill={labelColor}
                fontSize="7"
                fontWeight="700"
                fontFamily="Outfit, sans-serif"
                textAnchor="middle"
                dominantBaseline="middle"
                style={{ transformBox: 'view-box', transformOrigin: labelOrigin }}
              >
                {label}
              </text>
            </g>
          );
        })}
        <circle
          cx="50"
          cy="50"
          r="38"
          fill="none"
          stroke="rgba(255,255,255,0.95)"
          strokeWidth="1.5"
        />
      </svg>

      <div className="dashboard-header-morph__table">
        <div className="dashboard-header-morph__table-head">
          <span className="dashboard-header-morph__table-th dashboard-header-morph__table-th--dot" />
          <span className="dashboard-header-morph__table-th">Indicateur</span>
          <span className="dashboard-header-morph__table-th dashboard-header-morph__table-th--value">Valeur</span>
        </div>
        {TABLE_ROWS.map(({ id, label, value, color, glow }) => (
          <div key={id} className={`dashboard-header-morph__table-row dashboard-header-morph__table-row--${id}`}>
            <span
              className="dashboard-header-morph__table-dot"
              style={{ background: color, boxShadow: `0 0 8px ${glow}` }}
            />
            <span className="dashboard-header-morph__table-label">{label}</span>
            <span className="dashboard-header-morph__table-value" style={{ color }}>{value}</span>
          </div>
        ))}
      </div>

      {CELLS.map(({ id, colorClass }) => (
        <div
          key={id}
          className={`dashboard-header-morph__cell ${colorClass} dashboard-header-morph__cell--${id}`}
        >
          <div className="dashboard-header-morph__body" />
        </div>
      ))}

      <div className="dashboard-header-morph__bar-labels">
        {BAR_LABELS.map(({ id, value, color, left, top }) => (
          <span
            key={id}
            className={`dashboard-header-morph__bar-label dashboard-header-morph__bar-label--${id}`}
            style={{ left, top, color }}
          >
            {value}
          </span>
        ))}
      </div>

      <div className="dashboard-header-morph__floats">
        {CUBE_FLOATS.map(({ char, left, top, color, delay, duration, drift }, index) => (
          <span
            key={`${char}-${index}`}
            className={`dashboard-header-morph__float dashboard-header-morph__float--drift-${drift}`}
            style={{
              left,
              top,
              color,
              '--float-blink-dur': duration,
              animationDelay: `${delay}, ${delay}`,
            }}
          >
            {char}
          </span>
        ))}
      </div>
    </div>

    <style>{`
      .dashboard-header-morph {
        position: relative;
        flex-shrink: 0;
        width: 7rem;
        height: 6.5rem;
        align-self: center;
      }

      @media (min-width: 768px) {
        .dashboard-header-morph {
          width: 10rem;
          height: 8.5rem;
          align-self: auto;
        }
      }

      .dashboard-header-morph__stage {
        position: absolute;
        inset: 0;
        z-index: 1;
      }

      .dashboard-header-morph__pie {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 5.25rem;
        height: 5.25rem;
        margin-left: -2.625rem;
        margin-top: -2.625rem;
        overflow: visible;
        opacity: 0;
        visibility: hidden;
        transform: scale(0.55);
        animation: dashboard-morph-pie ${MORPH_CYCLE_S}s cubic-bezier(0.45, 0.05, 0.2, 1) infinite;
        filter: drop-shadow(0 0 10px rgba(245, 158, 11, 0.2));
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__pie {
          width: 6.25rem;
          height: 6.25rem;
          margin-left: -3.125rem;
          margin-top: -3.125rem;
        }
      }

      .dashboard-header-morph__pie-slice-body--orange,
      .dashboard-header-morph__pie-label--orange {
        animation-duration: ${MORPH_CYCLE_S}s;
        animation-timing-function: ease-out;
        animation-iteration-count: infinite;
      }

      .dashboard-header-morph__pie-slice-body--orange {
        animation-name: dashboard-morph-pie-zoom-orange;
      }

      .dashboard-header-morph__pie-label--orange {
        animation-name: dashboard-morph-pie-label-zoom-orange;
      }

      .dashboard-header-morph__table {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 6.5rem;
        margin-left: -3.25rem;
        margin-top: -2.35rem;
        border-radius: 0.5rem;
        border: 1px solid rgba(255, 255, 255, 0.14);
        background: rgba(15, 23, 42, 0.72);
        backdrop-filter: blur(6px);
        overflow: hidden;
        opacity: 0;
        visibility: hidden;
        transform: scale(0.88) translateY(3px);
        animation: dashboard-morph-table ${MORPH_CYCLE_S}s cubic-bezier(0.45, 0.05, 0.2, 1) infinite;
        box-shadow: 0 4px 18px rgba(0, 0, 0, 0.28);
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__table {
          width: 8.25rem;
          margin-left: -4.125rem;
          margin-top: -2.65rem;
        }
      }

      .dashboard-header-morph__table-head,
      .dashboard-header-morph__table-row {
        display: grid;
        grid-template-columns: 0.85rem 1fr auto;
        align-items: center;
        gap: 0.35rem;
        padding: 0.28rem 0.4rem;
      }

      .dashboard-header-morph__table-head {
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        background: rgba(255, 255, 255, 0.04);
      }

      .dashboard-header-morph__table-row {
        border-bottom: 1px solid rgba(255, 255, 255, 0.06);
        min-height: 1.15rem;
      }

      .dashboard-header-morph__table-row--orange {
        background: linear-gradient(90deg, rgba(245, 158, 11, 0.1) 0%, transparent 70%);
      }

      .dashboard-header-morph__table-row--violet {
        background: linear-gradient(90deg, rgba(139, 92, 246, 0.1) 0%, transparent 70%);
      }

      .dashboard-header-morph__table-row--blue {
        background: linear-gradient(90deg, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
      }

      .dashboard-header-morph__table-row .dashboard-header-morph__table-dot,
      .dashboard-header-morph__table-row .dashboard-header-morph__table-label,
      .dashboard-header-morph__table-row .dashboard-header-morph__table-value {
        opacity: 0;
        visibility: hidden;
        animation-duration: ${MORPH_CYCLE_S}s;
        animation-timing-function: cubic-bezier(0.34, 1.2, 0.64, 1);
        animation-iteration-count: infinite;
        animation-fill-mode: both;
      }

      .dashboard-header-morph__table-row--orange .dashboard-header-morph__table-dot,
      .dashboard-header-morph__table-row--orange .dashboard-header-morph__table-label,
      .dashboard-header-morph__table-row--orange .dashboard-header-morph__table-value {
        animation-name: dashboard-morph-table-cell-orange;
      }

      .dashboard-header-morph__table-row--violet .dashboard-header-morph__table-dot,
      .dashboard-header-morph__table-row--violet .dashboard-header-morph__table-label,
      .dashboard-header-morph__table-row--violet .dashboard-header-morph__table-value {
        animation-name: dashboard-morph-table-cell-violet;
      }

      .dashboard-header-morph__table-row--blue .dashboard-header-morph__table-dot,
      .dashboard-header-morph__table-row--blue .dashboard-header-morph__table-label,
      .dashboard-header-morph__table-row--blue .dashboard-header-morph__table-value {
        animation-name: dashboard-morph-table-cell-blue;
      }

      .dashboard-header-morph__table-th {
        font-family: Outfit, sans-serif;
        font-size: 0.42rem;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: rgba(255, 255, 255, 0.45);
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__table-head,
        .dashboard-header-morph__table-row {
          gap: 0.45rem;
          padding: 0.32rem 0.5rem;
        }

        .dashboard-header-morph__table-th {
          font-size: 0.48rem;
        }
      }

      .dashboard-header-morph__table-th--value {
        text-align: right;
      }

      .dashboard-header-morph__table-row:last-child {
        border-bottom: none;
      }

      .dashboard-header-morph__table-dot {
        width: 0.42rem;
        height: 0.42rem;
        border-radius: 9999px;
        flex-shrink: 0;
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__table-dot {
          width: 0.5rem;
          height: 0.5rem;
        }
      }

      .dashboard-header-morph__table-label {
        font-family: Manrope, sans-serif;
        font-size: 0.48rem;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.82);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .dashboard-header-morph__table-value {
        font-family: "JetBrains Mono", ui-monospace, monospace;
        font-size: 0.5rem;
        font-weight: 700;
        text-align: right;
        font-variant-numeric: tabular-nums;
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__table-label {
          font-size: 0.54rem;
        }

        .dashboard-header-morph__table-value {
          font-size: 0.58rem;
        }
      }

      .dashboard-header-morph__bar-labels {
        position: absolute;
        inset: 0;
        z-index: 3;
        pointer-events: none;
      }

      .dashboard-header-morph__bar-label {
        position: absolute;
        transform: translateX(-50%) translateY(4px) scale(0.8);
        font-family: "JetBrains Mono", ui-monospace, monospace;
        font-size: 0.52rem;
        font-weight: 700;
        line-height: 1;
        opacity: 0;
        visibility: hidden;
        text-shadow: 0 0 8px currentColor;
        font-variant-numeric: tabular-nums;
        animation-duration: ${MORPH_CYCLE_S}s;
        animation-timing-function: cubic-bezier(0.34, 1.2, 0.64, 1);
        animation-iteration-count: infinite;
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__bar-label {
          font-size: 0.6rem;
        }

        .dashboard-header-morph__bar-label--orange {
          left: 33.5% !important;
          top: 7.35rem !important;
        }

        .dashboard-header-morph__bar-label--violet {
          left: 52.5% !important;
          top: 7.35rem !important;
        }

        .dashboard-header-morph__bar-label--blue {
          left: 71.5% !important;
          top: 7.35rem !important;
        }
      }

      .dashboard-header-morph__bar-label--orange {
        animation-name: dashboard-morph-bar-label-orange;
      }

      .dashboard-header-morph__bar-label--violet {
        animation-name: dashboard-morph-bar-label-violet;
      }

      .dashboard-header-morph__bar-label--blue {
        animation-name: dashboard-morph-bar-label-blue;
      }

      .dashboard-header-morph__floats {
        position: absolute;
        inset: 0;
        z-index: 2;
        pointer-events: none;
        animation: dashboard-morph-floats-phase ${MORPH_CYCLE_S}s linear infinite;
      }

      .dashboard-header-morph__float {
        position: absolute;
        font-family: "JetBrains Mono", ui-monospace, monospace;
        font-size: 0.58rem;
        font-weight: 700;
        line-height: 1;
        opacity: 0;
        transform: translate(-50%, -50%) scale(0.65);
        text-shadow: 0 0 10px currentColor;
        animation-iteration-count: infinite;
      }

      @media (min-width: 768px) {
        .dashboard-header-morph__float {
          font-size: 0.68rem;
        }
      }

      .dashboard-header-morph__float--drift-a {
        animation-name: dashboard-morph-float-blink, dashboard-morph-float-drift-a;
        animation-duration: var(--float-blink-dur, 2s), 2.8s;
        animation-timing-function: ease-in-out, ease-in-out;
        animation-iteration-count: infinite, infinite;
      }

      .dashboard-header-morph__float--drift-b {
        animation-name: dashboard-morph-float-blink, dashboard-morph-float-drift-b;
        animation-duration: var(--float-blink-dur, 2s), 3.1s;
        animation-timing-function: ease-in-out, ease-in-out;
        animation-iteration-count: infinite, infinite;
      }

      .dashboard-header-morph__float--drift-c {
        animation-name: dashboard-morph-float-blink, dashboard-morph-float-drift-c;
        animation-duration: var(--float-blink-dur, 2s), 2.5s;
        animation-timing-function: ease-in-out, ease-in-out;
        animation-iteration-count: infinite, infinite;
      }

      .dashboard-header-morph__cell {
        position: absolute;
        top: 0;
        left: 0;
        width: 2.625rem;
        height: 2.625rem;
        animation-duration: ${MORPH_CYCLE_S}s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-name: dashboard-morph-cell-visibility;
      }

      .dashboard-header-morph__cell--orange {
        animation-name: dashboard-morph-cell-visibility, dashboard-morph-orange;
      }

      .dashboard-header-morph__cell--violet {
        animation-name: dashboard-morph-cell-visibility, dashboard-morph-violet;
      }

      .dashboard-header-morph__cell--blue {
        animation-name: dashboard-morph-cell-visibility, dashboard-morph-blue;
      }

      .dashboard-header-morph__body {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.6rem;
        transform-origin: center center;
        animation-duration: ${MORPH_CYCLE_S}s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }

      .dashboard-header-morph__cell--orange .dashboard-header-morph__body {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 55%, #d97706 100%);
        box-shadow: 0 0 14px rgba(245, 158, 11, 0.5);
        animation-name: dashboard-morph-body-orange;
      }

      .dashboard-header-morph__cell--violet .dashboard-header-morph__body {
        background: linear-gradient(135deg, #c084fc 0%, #8b5cf6 55%, #7c3aed 100%);
        box-shadow: 0 0 14px rgba(139, 92, 246, 0.45);
        animation-name: dashboard-morph-body-violet;
      }

      .dashboard-header-morph__cell--blue .dashboard-header-morph__body {
        background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 55%, #2563eb 100%);
        box-shadow: 0 0 14px rgba(59, 130, 246, 0.45);
        animation-name: dashboard-morph-body-blue;
      }

      .dashboard-header-morph__glow {
        position: absolute;
        border-radius: 9999px;
        filter: blur(20px);
        opacity: 0.32;
        pointer-events: none;
        animation: dashboard-morph-ambient ${MORPH_CYCLE_S}s ease-in-out infinite;
      }

      .dashboard-header-morph__glow--orange {
        width: 4rem;
        height: 4rem;
        top: 0;
        left: 0.5rem;
        background: #f59e0b;
      }

      .dashboard-header-morph__glow--violet {
        width: 3.5rem;
        height: 3.5rem;
        bottom: 0;
        left: 0;
        background: #8b5cf6;
        animation-delay: -${MORPH_S.barsHoldEnd}s;
      }

      .dashboard-header-morph__glow--blue {
        width: 3.5rem;
        height: 3.5rem;
        bottom: 0.25rem;
        right: 0;
        background: #3b82f6;
        animation-delay: -${MORPH_S.pieHoldEnd}s;
      }

      /*
        Cycle ${MORPH_CYCLE_S}s — une seule forme visible à la fois
        0–${MORPH_S.cubeSpread}s        cubes regroupés → séparés
        ${MORPH_S.cubeSpread}–${MORPH_S.cubeEnd}s   cubes + chiffres
        ${MORPH_S.cubeEnd}–${MORPH_S.barsReady}s    morph cubes → barres (${MORPH_TIMING.barsMorph}s)
        ${MORPH_S.barsReady}–${MORPH_S.barsHoldEnd}s barres (${MORPH_TIMING.barsHold}s)
        ${MORPH_S.barsHoldEnd}–${MORPH_S.pieReady}s  morph barres → camembert (${MORPH_TIMING.pieMorph}s)
        ${MORPH_S.pieReady}–${MORPH_S.pieHoldEnd}s  camembert (${MORPH_TIMING.pieHold}s)
          ${MORPH_S.pieReady}–${MORPH_S.pieZoomStart}s sans effet | zoom jaune ${MORPH_S.pieZoomStart}–${MORPH_S.pieZoomEnd}s | ${MORPH_S.pieZoomEnd}–${MORPH_S.pieHoldEnd}s sans effet
        ${MORPH_S.pieHoldEnd}–${MORPH_S.tableReady}s morph camembert → tableau (${MORPH_TIMING.tableMorph}s)
        ${MORPH_S.tableReady}–${MORPH_S.cycleEnd}s  tableau (${MORPH_TIMING.tableHold}s) → boucle
          lignes : +0s Produits | +1s Catégories | +2s Refact. | +3s complet
      */

      @keyframes dashboard-morph-pie-zoom-orange {
        0%, ${morphT(MORPH_S.pieZoomStart)} {
          transform: scale(1);
          filter: brightness(1);
        }
        ${morphT(MORPH_S.pieZoomStart + 0.15)} {
          transform: scale(1.22);
          filter: brightness(1.18) drop-shadow(0 0 4px rgba(255, 255, 255, 0.6));
        }
        ${morphT(MORPH_S.pieZoomStart + 1)} {
          transform: scale(1.1);
          filter: brightness(1.08) drop-shadow(0 0 2px rgba(255, 255, 255, 0.3));
        }
        ${morphT(MORPH_S.pieZoomEnd)}, 100% {
          transform: scale(1);
          filter: brightness(1);
        }
      }

      @keyframes dashboard-morph-pie-label-zoom-orange {
        0%, ${morphT(MORPH_S.pieZoomStart)} {
          transform: scale(1);
          filter: brightness(1);
        }
        ${morphT(MORPH_S.pieZoomStart + 0.15)} {
          transform: scale(1.35);
          filter: brightness(1.22) drop-shadow(0 0 3px rgba(255, 255, 255, 0.75));
        }
        ${morphT(MORPH_S.pieZoomStart + 1)} {
          transform: scale(1.15);
          filter: brightness(1.1) drop-shadow(0 0 1px rgba(255, 255, 255, 0.35));
        }
        ${morphT(MORPH_S.pieZoomEnd)}, 100% {
          transform: scale(1);
          filter: brightness(1);
        }
      }

      @keyframes dashboard-morph-bar-label-orange {
        0%, ${morphT(BAR_LABEL_APPEAR.orange)} {
          opacity: 0;
          visibility: hidden;
          transform: translateX(-50%) translateY(4px) scale(0.8);
        }
        ${morphT(BAR_LABEL_APPEAR.orange + 0.08)}, ${morphT(MORPH_S.barsHoldEnd)} {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0) scale(1);
        }
        ${morphT(MORPH_S.barsHoldEnd)}, 100% {
          opacity: 0;
          visibility: hidden;
          transform: translateX(-50%) translateY(4px) scale(0.8);
        }
      }

      @keyframes dashboard-morph-bar-label-violet {
        0%, ${morphT(BAR_LABEL_APPEAR.violet)} {
          opacity: 0;
          visibility: hidden;
          transform: translateX(-50%) translateY(4px) scale(0.8);
        }
        ${morphT(BAR_LABEL_APPEAR.violet + 0.08)}, ${morphT(MORPH_S.barsHoldEnd)} {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0) scale(1);
        }
        ${morphT(MORPH_S.barsHoldEnd)}, 100% {
          opacity: 0;
          visibility: hidden;
          transform: translateX(-50%) translateY(4px) scale(0.8);
        }
      }

      @keyframes dashboard-morph-bar-label-blue {
        0%, ${morphT(BAR_LABEL_APPEAR.blue)} {
          opacity: 0;
          visibility: hidden;
          transform: translateX(-50%) translateY(4px) scale(0.8);
        }
        ${morphT(BAR_LABEL_APPEAR.blue + 0.08)}, ${morphT(MORPH_S.barsHoldEnd)} {
          opacity: 1;
          visibility: visible;
          transform: translateX(-50%) translateY(0) scale(1);
        }
        ${morphT(MORPH_S.barsHoldEnd)}, 100% {
          opacity: 0;
          visibility: hidden;
          transform: translateX(-50%) translateY(4px) scale(0.8);
        }
      }

      @keyframes dashboard-morph-floats-phase {
        0%, ${morphT(MORPH_S.cubeSpread)} {
          opacity: 0;
          visibility: hidden;
        }
        ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
          opacity: 1;
          visibility: visible;
        }
        ${morphT(MORPH_S.cubeEnd)}, 100% {
          opacity: 0;
          visibility: hidden;
        }
      }

      @keyframes dashboard-morph-float-blink {
        0%, 100% {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0.6);
        }
        8%, 45% {
          opacity: 0.9;
          transform: translate(-50%, -50%) scale(1);
        }
        58% {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0.75);
        }
      }

      @keyframes dashboard-morph-float-drift-a {
        0%, 100% { margin-top: 0; margin-left: 0; }
        50% { margin-top: -2px; margin-left: 1px; }
      }

      @keyframes dashboard-morph-float-drift-b {
        0%, 100% { margin-top: 0; margin-left: 0; }
        50% { margin-top: 2px; margin-left: -2px; }
      }

      @keyframes dashboard-morph-float-drift-c {
        0%, 100% { margin-top: 0; margin-left: 0; }
        35% { margin-top: -1px; margin-left: 2px; }
        70% { margin-top: 1px; margin-left: -1px; }
      }

      @keyframes dashboard-morph-pie {
        0%, ${morphT(MORPH_S.barsHoldEnd)} {
          opacity: 0;
          visibility: hidden;
          transform: scale(0.55);
        }
        ${morphT(MORPH_S.pieReady)}, ${morphT(MORPH_S.pieHoldEnd)} {
          opacity: 1;
          visibility: visible;
          transform: scale(1);
        }
        ${morphT(MORPH_S.tableReady)}, 100% {
          opacity: 0;
          visibility: hidden;
          transform: scale(0.85);
        }
      }

      @keyframes dashboard-morph-table {
        0%, ${morphT(MORPH_S.pieHoldEnd)} {
          opacity: 0;
          visibility: hidden;
          transform: scale(0.88) translateY(3px);
        }
        ${morphT(MORPH_S.tableReady)}, 100% {
          opacity: 1;
          visibility: visible;
          transform: scale(1) translateY(0);
        }
      }

      @keyframes dashboard-morph-table-cell-orange {
        0%, ${morphT(TABLE_ROW_APPEAR.orange)} {
          opacity: 0;
          visibility: hidden;
          transform: translateY(2px);
        }
        ${morphT(TABLE_ROW_APPEAR.orange + 0.08)}, 100% {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
      }

      @keyframes dashboard-morph-table-cell-violet {
        0%, ${morphT(TABLE_ROW_APPEAR.violet)} {
          opacity: 0;
          visibility: hidden;
          transform: translateY(2px);
        }
        ${morphT(TABLE_ROW_APPEAR.violet + 0.08)}, 100% {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
      }

      @keyframes dashboard-morph-table-cell-blue {
        0%, ${morphT(TABLE_ROW_APPEAR.blue)} {
          opacity: 0;
          visibility: hidden;
          transform: translateY(2px);
        }
        ${morphT(TABLE_ROW_APPEAR.blue + 0.08)}, 100% {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
      }

      @keyframes dashboard-morph-cell-visibility {
        0%, ${morphT(MORPH_S.barsHoldEnd)} {
          opacity: 1;
          visibility: visible;
        }
        ${morphT(MORPH_S.pieReady)}, 100% {
          opacity: 0;
          visibility: hidden;
        }
      }

      @keyframes dashboard-morph-orange {
        0%, 100% {
          transform: translate(2.2rem, 1.75rem) rotate(32deg);
        }
        ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
          transform: translate(2.25rem, 0.35rem) rotate(45deg);
        }
        ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
          transform: translate(0.35rem, 3.25rem) rotate(0deg);
        }
      }

      @keyframes dashboard-morph-violet {
        0%, 100% {
          transform: translate(2.2rem, 1.75rem) rotate(-18deg) skewY(0deg);
        }
        ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
          transform: translate(0.75rem, 2.75rem) rotate(-28deg) skewY(10deg);
        }
        ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
          transform: translate(2.54rem, 3.25rem) rotate(0deg) skewY(0deg);
        }
      }

      @keyframes dashboard-morph-blue {
        0%, 100% {
          transform: translate(2.2rem, 1.75rem) rotate(14deg) skewY(0deg);
        }
        ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
          transform: translate(3.6rem, 2.75rem) rotate(28deg) skewY(-10deg);
        }
        ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
          transform: translate(4.73rem, 3.25rem) rotate(0deg) skewY(0deg);
        }
      }

      @keyframes dashboard-morph-body-orange {
        0%, ${morphT(MORPH_S.cubeEnd)}, 100% {
          border-radius: 0.6rem;
          transform: scale(1);
          transform-origin: center center;
        }
        ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
          border-radius: 0.4rem;
          transform-origin: 50% 100%;
          transform: scale(0.72, 1.05);
        }
      }

      @keyframes dashboard-morph-body-violet {
        0%, ${morphT(MORPH_S.cubeEnd)}, 100% {
          border-radius: 0.6rem;
          transform: scale(1);
          transform-origin: center center;
        }
        ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
          border-radius: 0.4rem;
          transform-origin: 50% 100%;
          transform: scale(0.72, 1.45);
        }
      }

      @keyframes dashboard-morph-body-blue {
        0%, ${morphT(MORPH_S.cubeEnd)}, 100% {
          border-radius: 0.6rem;
          transform: scale(1);
          transform-origin: center center;
        }
        ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
          border-radius: 0.4rem;
          transform-origin: 50% 100%;
          transform: scale(0.72, 1.85);
        }
      }

      @keyframes dashboard-morph-ambient {
        0%, ${morphT(MORPH_S.cubeEnd)} { opacity: 0.26; transform: scale(1); }
        ${morphT(MORPH_S.cubeEnd)}, ${morphT(MORPH_S.barsHoldEnd)} { opacity: 0.38; transform: scale(1.06); }
        ${morphT(MORPH_S.barsHoldEnd)}, ${morphT(MORPH_S.pieHoldEnd)} { opacity: 0.44; transform: scale(1.12); }
        ${morphT(MORPH_S.pieHoldEnd)}, 100% { opacity: 0.36; transform: scale(1.04); }
      }

      @media (min-width: 768px) {
        @keyframes dashboard-morph-orange {
          0%, 100% {
            transform: translate(3.7rem, 2.75rem) rotate(32deg);
          }
          ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
            transform: translate(3.6rem, 0.5rem) rotate(45deg);
          }
          ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
            transform: translate(1.35rem, 4.25rem) rotate(0deg);
          }
        }

        @keyframes dashboard-morph-violet {
          0%, 100% {
            transform: translate(3.7rem, 2.75rem) rotate(-18deg) skewY(0deg);
          }
          ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
            transform: translate(1.35rem, 4rem) rotate(-28deg) skewY(10deg);
          }
          ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
            transform: translate(3.69rem, 4.25rem) rotate(0deg) skewY(0deg);
          }
        }

        @keyframes dashboard-morph-blue {
          0%, 100% {
            transform: translate(3.7rem, 2.75rem) rotate(14deg) skewY(0deg);
          }
          ${morphT(MORPH_S.cubeSpread)}, ${morphT(MORPH_S.cubeEnd)} {
            transform: translate(5.85rem, 4rem) rotate(28deg) skewY(-10deg);
          }
          ${morphT(MORPH_S.barsReady)}, ${morphT(MORPH_S.barsHoldEnd)} {
            transform: translate(6.03rem, 4.25rem) rotate(0deg) skewY(0deg);
          }
        }
      }

      @media (prefers-reduced-motion: reduce) {
        .dashboard-header-morph__cell,
        .dashboard-header-morph__body,
        .dashboard-header-morph__glow,
        .dashboard-header-morph__pie,
        .dashboard-header-morph__pie-slice-body,
        .dashboard-header-morph__pie-label,
        .dashboard-header-morph__table,
        .dashboard-header-morph__table-row .dashboard-header-morph__table-dot,
        .dashboard-header-morph__table-row .dashboard-header-morph__table-label,
        .dashboard-header-morph__table-row .dashboard-header-morph__table-value,
        .dashboard-header-morph__floats,
        .dashboard-header-morph__bar-labels {
          animation: none !important;
        }

        .dashboard-header-morph__pie,
        .dashboard-header-morph__table,
        .dashboard-header-morph__floats,
        .dashboard-header-morph__bar-label {
          opacity: 0;
        }

        .dashboard-header-morph__cell--orange {
          transform: translate(3.7rem, 2.75rem) rotate(32deg);
        }

        .dashboard-header-morph__cell--violet {
          transform: translate(3.7rem, 2.75rem) rotate(-18deg) skewY(0deg);
        }

        .dashboard-header-morph__cell--blue {
          transform: translate(3.7rem, 2.75rem) rotate(14deg) skewY(0deg);
        }

        .dashboard-header-morph__glow {
          opacity: 0.18;
        }
      }
    `}</style>
  </div>
);
